import { orderBy, toLower, omit, isNumber } from 'lodash';
import moment from "moment";
import { formatCurrencyString } from './contractHelper';
import TimePeriods from '../constants/timePeriods';
import timeUnits from '../constants/timeUnits';

export const getPaymentScheduleAmountDescription = (payment, code) => {
  return payment.scheduled_amount_type == "AMOUNT" ? formatCurrencyString(payment.scheduled_amount, code) : `${payment.scheduled_amount}%`
}

export const getScheduledPaymentAmount = (payment, total) => {
  if (payment.scheduled_amount_type == "AMOUNT") {
    return Number(payment.scheduled_amount)
  } else {
    if (isNumber(total)) {
      const percentage = Number(payment.scheduled_amount) / 100
      return Number(total) * percentage;
    } else {
      return 0
    }
  }
}

export const getTotalScheduledPaymentAmounts = (payments, total) => {
  const nonFinalPayments = payments.filter(x => !x.final_payment)
  return nonFinalPayments.reduce((x,y) => {
    return x + getScheduledPaymentAmount(y, total);
  }, 0)
}

export const getPaymentScheduleDueDescription = (payment) => {
  var description = ""
  if (payment.time_value == 0 && payment.time_period == "AFTER_ISSUE_DATE") {
    return "On issue date"
  } else if (payment.time_value == 0 && (payment.time_period == "BEFORE_EVENT_DATE" || payment.time_period == "AFTER_EVENT_DATE")) {
    return "On event date"
  } else if (payment.time_period == "AFTER_ISSUE_DATE") {
    return `Within ${payment.time_value} ${toLower(payment.time_unit)}`
  } else if (payment.time_period == "BEFORE_EVENT_DATE") {
    description = "before event date"
  } else if (payment.time_period == "AFTER_EVENT_DATE") {
    description = "after event date"
  }
  return `${payment.time_value} ${toLower(payment.time_unit)} ${description}`
}

export const getPaymentScheduleDueOption = (payment) => {
  if (payment.time_value == 0 && payment.time_period == "AFTER_ISSUE_DATE") {
    return "ISSUE_DATE"
  } else if (payment.time_value == 0 && (payment.time_period == "BEFORE_EVENT_DATE" || payment.time_period == "AFTER_EVENT_DATE")) {
    return "EVENT_DATE"
  }
  return "CUSTOM"
}

export const getNumDays = (item) => {
  return item.time_unit == timeUnits.WEEKS ? Number(item.time_value) * 7 : Number(item.time_value)
}

export const getSortedPaymentReminders = (reminders) => {
  const NUM_DAYS = "num_days"
  const paymentReminders = reminders.map(x => {
    return {
      ...x,
      num_days: getNumDays(x)
    }
  })
  const beforeReminders = paymentReminders.filter(x => x.time_period == TimePeriods.BEFORE && x.time_value > 0)
  const sortedBeforeReminders = orderBy(beforeReminders, NUM_DAYS, "desc")
  const onDueDateReminders = paymentReminders.filter(x => x.time_value == 0)
  const afterReminders = paymentReminders.filter(x => x.time_period == TimePeriods.AFTER && x.time_value > 0)
  const sortedAfterReminders = orderBy(afterReminders, NUM_DAYS)
  const sortedReminders = sortedBeforeReminders.concat(onDueDateReminders).concat(sortedAfterReminders)
  const finalReminders = sortedReminders.map(x => omit(x, NUM_DAYS))
  return finalReminders
}

export const getSortedPaymentSchedules = (payments) => {
  const NUM_DAYS = "num_days"
  const mappedPayments = payments.map(x => {
    return {
      ...x,
      num_days: getNumDays(x.due_date_calculation)
    }
  })
  const nonFinalPayments = mappedPayments.filter(x => !x.final_payment)
  const finalPayments = mappedPayments.filter(x => x.final_payment)

  const afterIssueDatePayments = nonFinalPayments.filter(x => x.due_date_calculation.time_period == TimePeriods.AFTER_ISSUE_DATE)
  const sortedAfterIssueDatePayments = orderBy(afterIssueDatePayments, NUM_DAYS)
  const beforeEventDatePayments = nonFinalPayments.filter(x => x.due_date_calculation.time_period == TimePeriods.BEFORE_EVENT_DATE)
  const sortedBeforeEventDatePayments = orderBy(beforeEventDatePayments, NUM_DAYS, "desc")
  const afterEventDatePayments = nonFinalPayments.filter(x => x.due_date_calculation.time_period == TimePeriods.AFTER_EVENT_DATE)
  const sortedAfterEventDatePayments = orderBy(afterEventDatePayments, NUM_DAYS)
  
  const sortedPayments = sortedAfterIssueDatePayments.concat(sortedBeforeEventDatePayments).concat(sortedAfterEventDatePayments).concat(finalPayments)
  // Remove "num_days" from each object before returning
  const finalSortedPayments = sortedPayments.map(x => omit(x, NUM_DAYS))

  return finalSortedPayments
}

export const getDateFromDueDateCalculation = (calculation, event_date, issue_date, settings = {}) => {
  var eventDate = moment()
  var issueDate = moment()
  if (event_date) {
    eventDate = moment(event_date, "YYYY-MM-DD")
  }
  if (issue_date) {
    issueDate = moment(issue_date, "YYYY-MM-DD")
  }

  var finalDate = issueDate
  var numDays = getNumDays(calculation)

  if (calculation.time_period == TimePeriods.AFTER_ISSUE_DATE) {
    // Calculate X amount of days or weeks after the current date
    finalDate = issueDate.add(numDays, "days")
  } else if (calculation.time_period == TimePeriods.BEFORE_EVENT_DATE) {
    // Calculate X amount of days or weeks before the event date
    finalDate = eventDate.subtract(numDays, "days")
  } else if (calculation.time_period == TimePeriods.AFTER_EVENT_DATE) {
    // Calculate X amount of days or weeks after the event date
    finalDate = eventDate.add(numDays, "days")
  }

  return finalDate.format("YYYY-MM-DD")
}